/**
 * Internal dependencies
 */
import Block from './block'
import renderFrontend from '../../util/render-frontend.js'

const getProps = el => ( {
	attributes: JSON.parse( el.dataset.attributes ),
	hasVisibilitySensor: true,
} )

renderFrontend(
	'.wp-block-bwgb-products-simple__content',
	Block,
	getProps
)
